const apiVersion = 'v1'

export const BASE_PATH = `api/${apiVersion}/source-execution-logs/`
export const CLIENT_SOURCE_EXECUTION_LOG_PATH = `api/${apiVersion}/clients/:client_session_id/sources/`
